import Layout from "../components/Layout";
import React, {useEffect, useState, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {Formik } from 'formik'
import TextField from "../components/TextField";
import axios from 'axios';
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import * as Yup from "yup";
import { Toast } from 'primereact/toast';

const PasswordChange = () => {
    const primeToast = useRef(null)
    const {user} = useSelector((state) => state["auth"]);
    const [isLoading,setIsLoading] = useState(false)
    //const [userInformation, setUserInformation] = ([])
    const [userInformation, setUserInformation] = useState({
        registerID: user.registerID,
        userName: "",
        password: "",
        email:"",
        contactNo:""
    })
    useEffect(() => {
        GetUserInformation(user.registerID);
    }, [])
    // const formik = useFormik({
    //     initialValues:{
    //     userName: userInformation.userName ===""?"": "Hi"
    //     },
    //     enableReinitialze: true

    // });

    const GetUserInformation=(id)=>{
        axios.get(BASE_URL + `/api/register/GetUserData/${id}`)
            .then(response => {
                setUserInformation({
                    registerID: user.registerID,
                    userName:response.data[0].userName,
                    password:response.data[0].password,
                    email:response.data[0].email,
                    contactNo:response.data[0].contactNo
            });
            })
            .catch(e => {
                console.log(e)
            })
    }
    
    // const postData = (event) => {
    //     event.preventDefault();
    //     console.log(event);
    // }

    const validation = Yup.object({
        //userName: Yup.string().required("This field is required"),
        password: Yup.string().min(2).max(20).required("This field is required"),
        email: Yup.string().required("This field is required"),
        contactNo: Yup.string().min(11).required("This field is required")
    })

    

    return (<Layout>
        <Toast ref={primeToast}/>
        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6>Update Information</h6>
            </div>
            <div className="card-body">            
            <Formik  validationSchema={validation}
        enableReinitialize={true} 
       initialValues={{ registerID:user.registerID, userName: userInformation.userName===""?"":userInformation.userName,
       password: userInformation.password===""?"":userInformation.password,
       email: userInformation.email===""?"":userInformation.email,
       contactNo: userInformation.contactNo===""?"":userInformation.contactNo }}
       onSubmit={(values, actions) => {
        const data = JSON.stringify(values, null, 2);
        //console.log(data);

        axios.post(BASE_URL + "/api/register/UpdatePassword", data)
                                .then(response => {
                                    if (response.status === 200) {
                                        primeToast.current.show({ 
                                            severity: 'success', 
                                            summary: 'success', 
                                            detail: 'Information Updated Successfully..!', 
                                            life: 3000 });                                       
                                    }
                                    else{
                                        primeToast.current.show({
                                            severity: 'error',
                                            summary: 'error',
                                            detail: 'Information Updated Not Completed please contact with MIS team..!',
                                            life: 3000
                                        });
                                    }
                                }).catch(e => {
                                    primeToast.current.show({
                                        severity: 'error',
                                        summary: 'error',
                                        detail: 'Information Updated Not Completed please contact with MIS team..!',
                                        life: 3000
                                    });
                                })
       
       }}
     >
       {props => (
         <form onSubmit={props.handleSubmit}>
          <div className="row">
            <div className="col-6">
                <TextField label={'User Name'} type="text" name="userName"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.userName} disabled placeholder="Enter User Name.."/>         
            </div>
            <div className="col-6">
                <TextField label={'Password'} type="password" name="password" 
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.password} placeholder="Enter Password.."/>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
                <TextField label={'Email'} type="email" name="email"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.email} placeholder="Enter Email.."/>
            </div>
            <div className="col-6">
                <TextField label={'Contact No'} type="text" name="contactNo"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.contactNo} placeholder="Enter Contact.."/>      
            </div>
          </div>
            <div className="row">
                <div className="col-12">
                {props.errors.name && <div id="feedback">{props.errors.name}</div>}
                    <button type="submit" className="btn btn-primary"><i class="bi bi-check2-all"></i> Submit</button>
                </div>
            </div>
            <TextField label={''} type="hidden" name="registerID"  
            onChange={props.handleChange} 
            onBlur={props.handleBlur} value={props.values.registerID}/>
         </form>
       )}
            </Formik>
            </div>
        </div>

    </Layout>)
}

export default PasswordChange